import { EndSplashProduct } from '@common/models';
import { createFetchProductsHook } from '@core/utils/createFetchProductsHook';
import { useFetchEndSplashQuery } from '@ee-api/endsplash-api/endSplashService';
import { useSelectedMaterial } from '@ee-api/materials-api/useSelectedMaterial';

type UseEndSplashReturn = ReturnType<typeof _useEndSplash> & {
    data?: EndSplashProduct[];
    EndSplashItems: EndSplashProduct[];
    isFetchingEndSplash: boolean;
};

const emptyArray = [] satisfies EndSplashProduct[];

const _useEndSplash = createFetchProductsHook({
    apiQueryHook: useFetchEndSplashQuery,
});

export const useEndSplash = (): UseEndSplashReturn => {
    const { isLaminateSelected } = useSelectedMaterial();

    return _useEndSplash({
        skip: !isLaminateSelected,
        selectFromResult: (result) => {
            return {
                EndSplashItems: result.isSuccess && result.data ? result.data : emptyArray,
                isFetchingEndSplash: result.isFetching,
                ...result,
            };
        },
    });
};
